import { render, staticRenderFns } from "./img-upload.vue?vue&type=template&id=0a1d4c1e&scoped=true"
import script from "./img-upload.vue?vue&type=script&lang=js"
export * from "./img-upload.vue?vue&type=script&lang=js"
import style0 from "./img-upload.vue?vue&type=style&index=0&id=0a1d4c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1d4c1e",
  null
  
)

export default component.exports